import { render, staticRenderFns } from "./Transactions.vue?vue&type=template&id=10e1f38b&scoped=true"
import script from "./Transactions.vue?vue&type=script&lang=ts"
export * from "./Transactions.vue?vue&type=script&lang=ts"
import style0 from "./Transactions.vue?vue&type=style&index=0&id=10e1f38b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e1f38b",
  null
  
)

export default component.exports